import { z } from "zod";

export const authScheme = z.object({
  // Comprimento varia por país (BR 11, PT/PY 9, UY 8) — a completude do número
  // por país é validada no componente; aqui só garantimos o mínimo possível.
  phone: z.string().min(8, "Número inválido"),
  password: z.string().min(1, "Senha obrigatória"),
});

export type AuthScheme = z.infer<typeof authScheme>;
